var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, keyframes } from 'shared/components';
import { useShouldShowTourItem } from '../hooks';
var animationOffset = '8px';
var placementAnimations = {
    bottom: keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: translateY(0px) }\n  to { transform: translateY(", ") }\n"], ["\n  from { transform: translateY(0px) }\n  to { transform: translateY(", ") }\n"])), animationOffset),
    top: keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from { transform: translateY(0px) }\n  to { transform: translateY(-", ") }\n"], ["\n  from { transform: translateY(0px) }\n  to { transform: translateY(-", ") }\n"])), animationOffset),
    right: keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from { transform: translateX(0px) }\n  to { transform: translateX(", ") }\n"], ["\n  from { transform: translateX(0px) }\n  to { transform: translateX(", ") }\n"])), animationOffset),
    left: keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from { transform: translateX(0px) }\n  to { transform: translateX(-", ") }\n"], ["\n  from { transform: translateX(0px) }\n  to { transform: translateX(-", ") }\n"])), animationOffset),
};
export var TourTooltip = function (_a) {
    var tourFlag = _a.tourFlag, placement = _a.placement, _b = _a.enabled, enabled = _b === void 0 ? true : _b, tooltipProps = __rest(_a, ["tourFlag", "placement", "enabled"]);
    var shouldShowTour = useShouldShowTourItem(tourFlag);
    var animation = "".concat(placementAnimations[placement], " infinite .5s ease-in-out alternate");
    return (_jsx(Tooltip, __assign({ isOpen: shouldShowTour && enabled, animation: animation, hasArrow: true, placement: placement }, tooltipProps)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
